module.exports = __webpack_public_path__ + "static/media/fb-create-adaccount-2-en.afc757ae.png";